import React, {useState} from "react";
import './style.css'

export default function Switch({name = '', checked, onSwitch}) {
    return (
        <label className="n-switch">
            <input
                type="checkbox"
                name={name}
                checked={checked}
                onChange={() => onSwitch(!checked)}/>
            <span className="n-slider n-round"></span>
        </label>
    )
}


// WEBPACK FOOTER //
// ./src/new-components/switch/index.js